// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2v6q2","table":"styles_table__Rc0I6"};